module.exports = __webpack_public_path__ + "img/lincoln-red.435b33b0.png";